var map = {
	"./12.svg": "fd28",
	"./13.svg": "6056",
	"./14.svg": "1518",
	"./15.svg": "1043",
	"./2.1.svg": "978c",
	"./2.2.svg": "f489",
	"./3.1.svg": "c30e",
	"./3.2.svg": "17f1",
	"./adTemplate.svg": "b6e8",
	"./config.svg": "18fc",
	"./dashboard.svg": "f782",
	"./entryConfig.svg": "cd39",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./mob.svg": "d047",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./table.svg": "47f1",
	"./template.svg": "dcbb",
	"./test.svg": "fe8d",
	"./test1.svg": "e4e6",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";